export class ErrorResult {
    public type?: string;
    public title?: string;
    public detail?: string;
    public instance?: string;
    public status?: number;
    public errors?: ErrorResult[];
};
